import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { NavLink, NavLinkProps } from 'react-router-dom';

export interface SideBarItemProps {
  /**
   * The link to render to.
   */
  to: string;
  /**
   * The Text to show on the link
   */
  children: React.ReactNode;
  /**
   * The Icon to render
   */
  icon: React.ReactNode;
  /**
   * Match exact link.
   */
  exact?: boolean;
  /**
   * Click Handler
   */
  onClick?: (...a: any[]) => any;
}

/**
 * Render a sidebar item with react-router link to the given route.
 * Automatically highlights the item when route is selected.
 * @param props
 */
export function SideBarItem({
  to,
  children,
  icon,
  exact = true,
  onClick = null,
}: SideBarItemProps) {
  return (
    <ListItem
      onClick={onClick}
      button
      component={NavLink}
      exact={exact}
      to={to}
      activeClassName="Mui-selected">
      <ListItemIcon style={{ minWidth: 40 }}>{icon}</ListItemIcon>
      <ListItemText primary={children} />
    </ListItem>
  );
}
